document.addEventListener('DOMContentLoaded', function () {
    const volumeInput = document.getElementById('volume');
    const volumeToggle = document.getElementById('volumeToggle');
    const currentMgInput = document.getElementById('currentMg');
    const desiredMgInput = document.getElementById('desiredMg');
    const productSelect = document.getElementById('product');
    const resultDiv = document.getElementById('result');
    const calculateButton = document.getElementById('calculateMagnesiumButton');

    if (
        !volumeInput ||
        !volumeToggle ||
        !currentMgInput ||
        !desiredMgInput ||
        !productSelect ||
        !resultDiv ||
        !calculateButton
    ) {
        console.error('Required DOM elements not found for Magnesium Calculator');
        return;
    }

    function calculateDose() {
        const volume = parseFloat(volumeInput.value);
        const volumeUnit = volumeToggle.checked ? 'liters' : 'gallons';
        const currentMg = parseFloat(currentMgInput.value);
        const desiredMg = parseFloat(desiredMgInput.value);
        const productParts = productSelect.value.split('|');
        const productName = productSelect.options[productSelect.selectedIndex].text;
        const value = parseFloat(productParts[1]);
        const type = productParts[2];

        resultDiv.style.display = 'none';
        resultDiv.innerHTML = '';

        if (isNaN(volume) || volume <= 0) {
            resultDiv.innerHTML = '<span class="result-label">Magnesium Dose Estimate</span>Please enter a valid aquarium volume greater than 0.';
            resultDiv.style.display = 'block';
            return;
        }

        if (isNaN(currentMg) || currentMg <= 0) {
            resultDiv.innerHTML = '<span class="result-label">Magnesium Dose Estimate</span>Please enter a valid current magnesium level greater than 0.';
            resultDiv.style.display = 'block';
            return;
        }

        if (isNaN(desiredMg) || desiredMg <= 0) {
            resultDiv.innerHTML = '<span class="result-label">Magnesium Dose Estimate</span>Please enter a valid desired magnesium level greater than 0.';
            resultDiv.style.display = 'block';
            return;
        }

        if (currentMg < 600 || currentMg >= 2000) {
            resultDiv.innerHTML = '<span class="result-label">Magnesium Dose Estimate</span>Current magnesium level must be between 600 and 2000 ppm.';
            resultDiv.style.display = 'block';
            return;
        }

        if (desiredMg < 600 || desiredMg >= 2000) {
            resultDiv.innerHTML = '<span class="result-label">Magnesium Dose Estimate</span>Desired magnesium level must be between 600 and 2000 ppm.';
            resultDiv.style.display = 'block';
            return;
        }

        if (desiredMg <= currentMg) {
            resultDiv.innerHTML = '<span class="result-label">Magnesium Dose Estimate</span>Desired magnesium level must be higher than current level.';
            resultDiv.style.display = 'block';
            return;
        }

        const volumeLiters = volumeUnit === 'liters' ? volume : volume * 3.78541;
        const deltaMg = desiredMg - currentMg;

        if (type === 'liquid') {
            const amountMl = (deltaMg * volumeLiters * 1000) / value;
            const flOz = amountMl * 0.033814;
            const tsp = amountMl * 0.202884;

            let resultText = '<span class="result-label">Magnesium Dose Estimate</span>';
            resultText += `<strong>Add approximately ${amountMl.toFixed(2)} mL</strong> of ${productName}.`;
            resultText += `<br>${flOz.toFixed(2)} fl oz`;
            resultText += `<br>${tsp.toFixed(2)} tsp`;

            if (deltaMg > 100) {
                resultText += `<span class="inline-warning">Warning: Magnesium increase of ${deltaMg.toFixed(2)} ppm exceeds 100 ppm per day. Spread the dose across multiple days.</span>`;
            }

            resultDiv.innerHTML = resultText;
            resultDiv.style.display = 'block';
        }
    }

    calculateButton.addEventListener('click', calculateDose);
    window.calculateDose = calculateDose;
});